export default __webpack_public_path__ + "static/media/Finished Attendances.edf5c2cc.svg";